import { tmxApiCall } from '.'

// Utilities
import Logger from '../utility/loggerUtil'

export default {
  /**
   * Gets a list of appointment times available at a given store, in the store's timezone.
   * @param {Number} storeId - The store identifier.
   * @param {Number} numberOfDays - The number of days to include in the response times (0 = just today if before closing, 1 = next available day (today if before closing), 2 = next two available days).
   * @param {Boolean} excludeWeekends - True if response should exclude times on weekends.
   * @param {Number} [storeNumber] - The store number.
   * @returns {Promise<{appointments: [String]}>} The available appointment times for the given store.
   */
  async getAppointmentTimes (storeId, numberOfDays, excludeWeekends, storeNumber = undefined) {
    Logger.info('Started Get LMS Appointment Times')
    return tmxApiCall('get', '/appointmentTimes', {
      params: {
        storeId,
        numberOfDays,
        excludeWeekends,
        storeNumber
      }
    })
  },

  /**
   * *** DEPRECATED *** Use the new /appointmentTimes endpoint instead of this one!
   * Gets a list of appointment times available at a given store, using the passed in client timezone.
   * @deprecated since version 2.6.5.
   * @param {Number} storeId - The store identifier.
   * @param {String} timezone - The client device's current timezone.
   * @returns {Promise<[String]>} The available appointment time slots for the given store.
   */
  async getAppointmentSlots (storeId, timezone) {
    Logger.info('Started get appointment slots request.')
    return tmxApiCall('get', '/appointmentslots', {
      params: {
        storeId,
        timeZone: timezone
      }
    })
  },

  /**
   * Creates a new appointment for the customers associated with a specific store (used for express lane, product switch, and product switch auto create appointments).
   * @param {Number} storeId - The store identifier (new target store if product switch related appointment is being created).
   * @param {String} loanHeader - The loan header associated with the appointment being created.
   * @param {String} dateTime - The date and time to create the appointment (not required for product switch auto-create appointments).
   * @param {Number} [appointmentId] - Optionally, the ID of an existing appointment, if we are editing an existing appointment.
   * @param {String} timezone - The client device's current timezone.
   * @param {Number} appointmentType - The type of appointment to create (express lane, product switch manual, and product switch auto-create).
   * @param {Number} [oldStoreId] - Optionally, the old store ID if this is a product switch related appointment create request.
   * @param {Number} [storeNumber] - Optionally, the store number to associate the appointment to.
   * @returns {Promise<[String]>} The available appointment time slots for the given store.
   */
  async createAppointment (storeId, loanHeader, dateTime, appointmentId, timeZone, appointmentType, oldStoreId = undefined, storeNumber = undefined) {
    Logger.info('Started create appointment request.')
    return tmxApiCall('post', '/schedappointment', {
      storeId,
      storeNumber,
      loanHdr: loanHeader,
      appointmentDate: dateTime,
      id: appointmentId,
      timeZone,
      appointmentType,
      oldStoreId
    })
  },

  async getAppointments (timeZone, storeNumber, storeId, appointmentType) {
    Logger.info('Started get appointments request.')
    return tmxApiCall('get', '/schedappointment', {
      params: {
        timeZone,
        storeNumber,
        storeId,
        appointmentType
      }
    })
  }
}
